import React, { useState, useEffect, useRef } from "react";
import carregando from "../../assets/loading.gif";
import api from "../../services/api";
import Header from "../../Header";
import SideMenu from "../../SideMenu";
import Footer from "../../Footer";
import {
  idStr,
  TreinamentosPermitidosModalPanel,
} from "./TreinamentosPermitidosModalPanel";

const MODAL_ID_NOVO_CLIENTE = "modal-treinamentos-novo-cliente";

export default function New_Cliente({ history }) {
  const [nome, setNome] = useState("");
  const [endereco, setEndereco] = useState("");
  const [loading, setLoading] = useState("");
  const [catalogoProdutos, setCatalogoProdutos] = useState([]);
  const [treinamentosSelecionados, setTreinamentosSelecionados] = useState([]);
  const modalTreinamentosRef = useRef(null);

  async function handleSubmit(event) {
    setLoading(true);
    event.preventDefault();

    const dataobj = {
      nome: nome,
      endereco: endereco,
      treinamentosPermitidos: treinamentosSelecionados,
    };

    await api.post("/treinamentos/empresa/", dataobj);
    setLoading(false);
    history.push("/clientes");
  }

  function removerTreinamento(id) {
    const sid = idStr(id);
    setTreinamentosSelecionados((prev) =>
      prev.filter((x) => idStr(x) !== sid)
    );
  }

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const empresaid = localStorage.getItem("sgiempresaid");
        const isMaster = localStorage.getItem("sgimaster");
        const response = await api.get("/treinamentos/produto", {
          headers: { "x-tenantid": empresaid, isMaster },
        });
        if (!cancelled) {
          const lista = (response.data || []).filter((p) => !p.isIntegracao);
          setCatalogoProdutos(lista);
        }
      } catch (e) {
        if (!cancelled) setCatalogoProdutos([]);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  useEffect(() => {
    setTimeout(() => {
      if (document.getElementById("menu_cliente")) {
        document.getElementById("menu_cliente").className = "active";
      }
    }, 50);
  }, []);

  return (
    <>
      <Header />
      <SideMenu />

      <div className="content-wrapper">
        <section className="content-header">
          <h1>Novo Cliente</h1>
        </section>

        <section className="content">
          <div className="row">
            <div className="col-md-12">
              <div className="box box-info">
                {loading && (
                  <div style={{ alignItems: "center", textAlign: "center" }}>
                    <img src={carregando} width="80" alt="" />
                  </div>
                )}

                <form className="form-horizontal" onSubmit={handleSubmit}>
                  <div className="box-body">
                    <div className="form-group">
                      <label
                        className="col-sm-2 control-label"
                        htmlFor="nome"
                      >
                        Nome*
                      </label>
                      <div className="col-sm-10">
                        <input
                          id="nome"
                          placeholder="Nome do Cliente"
                          className="form-control"
                          value={nome}
                          required
                          maxLength={400}
                          onChange={(event) => setNome(event.target.value)}
                        />
                      </div>
                    </div>

                    <div className="form-group">
                      <label
                        className="col-sm-2 control-label"
                        htmlFor="endereco"
                      >
                        Endereço*
                      </label>
                      <div className="col-sm-10">
                        <input
                          id="endereco"
                          placeholder="Endereço do Cliente"
                          className="form-control"
                          value={endereco}
                          required
                          onChange={(event) => setEndereco(event.target.value)}
                        />
                      </div>
                    </div>

                    <div className="form-group">
                      <label
                        className="col-sm-2 control-label"
                        htmlFor="logo"
                      >
                        Logo*
                      </label>
                      <div className="col-sm-10">
                        <input
                          type="file"
                          accept="image/png, image/jpeg"
                          id="logo"
                          placeholder="Logotipo"
                          className="form-control"
                        />
                      </div>
                    </div>

                    <div className="form-group">
                      <label className="col-sm-2 control-label">
                        Treinamentos
                      </label>
                      <div className="col-sm-10">
                        <div
                          className="box box-default"
                          style={{ marginBottom: 0 }}
                        >
                          <div className="box-body table-responsive no-padding">
                            <table className="table table-hover">
                              <tbody>
                                <tr>
                                  <th>#</th>
                                  <th>Treinamento</th>
                                  <th>Ação</th>
                                </tr>
                                {treinamentosSelecionados.length === 0 ? (
                                  <tr>
                                    <td colSpan={3} className="text-muted">
                                      Nenhum treinamento selecionado. Use o
                                      botão abaixo para adicionar.
                                    </td>
                                  </tr>
                                ) : (
                                  treinamentosSelecionados.map((id, index) => {
                                    const sid = idStr(id);
                                    const item = catalogoProdutos.find(
                                      (p) => idStr(p._id) === sid
                                    );
                                    return (
                                      <tr key={sid}>
                                        <td>{index + 1}</td>
                                        <td>{item ? item.titulo : id}</td>
                                        <td>
                                          <a
                                            onClick={() =>
                                              removerTreinamento(id)
                                            }
                                            style={{ cursor: "pointer" }}
                                            role="button"
                                            tabIndex={0}
                                            onKeyDown={(e) =>
                                              e.key === "Enter" &&
                                              removerTreinamento(id)
                                            }
                                          >
                                            <i
                                              className="fa fa-remove"
                                              style={{ color: "red" }}
                                            />
                                          </a>
                                        </td>
                                      </tr>
                                    );
                                  })
                                )}
                              </tbody>
                            </table>
                          </div>
                          <div
                            className="box-footer"
                            style={{ borderTop: 0 }}
                          >
                            <button
                              className="btn btn-success"
                              data-toggle="modal"
                              data-target={`#${MODAL_ID_NOVO_CLIENTE}`}
                              type="button"
                              style={{ marginRight: 8 }}
                              onClick={() =>
                                modalTreinamentosRef.current?.prepararAbertura(
                                  treinamentosSelecionados
                                )
                              }
                            >
                              + Adicionar Novo Treinamento
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="box-footer">
                    <button
                      className="btn btn-default"
                      style={{ marginRight: 8 }}
                      type="button"
                      onClick={() => history.push("/clientes")}
                    >
                      Voltar
                    </button>
                    <button type="submit" className="btn btn-info">
                      Salvar
                    </button>
                  </div>

                  {loading && (
                    <div style={{ alignItems: "center", textAlign: "center" }}>
                      <img src={carregando} width="80" alt="" />
                    </div>
                  )}
                </form>
              </div>
            </div>
          </div>
        </section>
      </div>

      <TreinamentosPermitidosModalPanel
        ref={modalTreinamentosRef}
        modalId={MODAL_ID_NOVO_CLIENTE}
        catalogoProdutos={catalogoProdutos}
        onAplicarSelecao={setTreinamentosSelecionados}
      />

      <Footer />
    </>
  );
}
